module.exports = __webpack_public_path__ + "media/images/upload_image_default-110e26460d27ed32becf2516390365f4.png";